/* ==========================================================
   HS Before & After
   ========================================================== */

(function () {
  const SECTION_SELECTOR = "[data-hs-before-after]";

  function initSection(section) {
    if (!section || section.dataset.hsBaReady === "true") return;

    const tabs = Array.from(section.querySelectorAll(".hs-ba-tab"));
    const panels = Array.from(section.querySelectorAll(".hs-ba-panel"));
    if (!tabs.length || !panels.length) return;

    section.dataset.hsBaReady = "true";

    const dots = Array.from(section.querySelectorAll(".hs-ba-dot"));

    function activate(id, moveFocus) {
      tabs.forEach((tab) => {
        const active = tab.dataset.tab === id;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });

      panels.forEach((panel) => {
        panel.classList.toggle("is-active", panel.dataset.panel === id);
      });

      dots.forEach((dot) => {
        dot.classList.toggle("is-active", dot.dataset.dot === id);
      });
    }

    // Expose so the theme editor listeners below can drive this section
    section.hsBaActivate = activate;

    function step(fromId, delta) {
      const index = tabs.findIndex((tab) => tab.dataset.tab === fromId);
      if (index < 0) return;
      const next = (index + delta + tabs.length) % tabs.length;
      return tabs[next].dataset.tab;
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activate(tab.dataset.tab, false));

      tab.addEventListener("keydown", (event) => {
        const rtl = getComputedStyle(section).direction === "rtl";
        let targetId = null;

        switch (event.key) {
          case "ArrowRight":
            targetId = step(tab.dataset.tab, rtl ? -1 : 1);
            break;
          case "ArrowLeft":
            targetId = step(tab.dataset.tab, rtl ? 1 : -1);
            break;
          case "Home":
            targetId = tabs[0].dataset.tab;
            break;
          case "End":
            targetId = tabs[tabs.length - 1].dataset.tab;
            break;
          default:
            return;
        }

        event.preventDefault();
        if (targetId) activate(targetId, true);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => activate(dot.dataset.dot, false));
    });

    // Horizontal swipe between panels on touch devices
    let startX = null;
    let startY = null;

    panels.forEach((panel) => {
      const compare = panel.querySelector(".hs-ba-compare");
      if (!compare) return;

      compare.addEventListener(
        "touchstart",
        (event) => {
          startX = event.changedTouches[0].clientX;
          startY = event.changedTouches[0].clientY;
        },
        { passive: true }
      );

      compare.addEventListener(
        "touchend",
        (event) => {
          if (startX === null) return;

          const dx = event.changedTouches[0].clientX - startX;
          const dy = event.changedTouches[0].clientY - startY;
          startX = null;
          startY = null;

          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;

          const rtl = getComputedStyle(section).direction === "rtl";
          const forward = rtl ? dx > 0 : dx < 0;
          const targetId = step(panel.dataset.panel, forward ? 1 : -1);
          if (targetId) activate(targetId, false);
        },
        { passive: true }
      );
    });

    const initial = tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0];
    activate(initial.dataset.tab, false);
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
    if (scope.matches && scope.matches(SECTION_SELECTOR)) initSection(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  // Theme editor
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));

  document.addEventListener("shopify:block:select", (event) => {
    const section = event.target.closest(SECTION_SELECTOR);
    if (!section) return;
    initSection(section);
    const id = event.target.dataset.tab || event.target.dataset.panel;
    if (id && typeof section.hsBaActivate === "function") section.hsBaActivate(id, false);
  });
})();